// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d97b5fa3","239":"c4b702dd","453":"2a54215c","732":"dbaf4797"}[chunkId] + ".chunk.js";
};